import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { clearAuthData, getUserData, hasRole, isAuthenticated } from "../auth";
import { useSelector } from "react-redux";
 import HomeIcon from '@mui/icons-material/Home';
 import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
 import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
 import StorefrontIcon from '@mui/icons-material/Storefront';
 import StoreIcon from '@mui/icons-material/Store';
 import ShopIcon from '@mui/icons-material/Shop';
 import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
 import DashboardIcon from '@mui/icons-material/Dashboard';
import { LoginOutlined } from "@mui/icons-material";
import { useGetPendingCartCountBySellerQuery } from "../apis/OrderAPi";
import { Typography } from "@mui/material";
 
const HeaderFooter = () => {
  const [scroll, setScroll] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
   const userData = getUserData();
  const roles = userData?.role || []; // Extract roles or use an empty array if not available
  const sellerId = userData?.uid || "";
  const { data: count } = useGetPendingCartCountBySellerQuery(sellerId, {
    pollingInterval: 5000, // Poll every 5000ms (5 seconds)
  });
  
   
  const isCustomer = hasRole('ROLE_CUSTOMER'); // Check if the user has the 'customer' role
  const isVendor = hasRole('ROLE_VENDER'); // Check if the user has the 'vendor' role
  const cartItems = useSelector((state) => state.product.cart); // Access cart items from Redux store
  const wishList = useSelector((state) => state.product.wishList); // Access wishList items from Redux store
  const compare = useSelector((state) => state.product.compare); // Access compare items from Redux store

  const isLoggedInCustomer = loggedIn && isCustomer; // true if logged in and customer

  useEffect(() => {
    const checkAuthStatus = () => {
      const authStatus = isAuthenticated();
      setLoggedIn(authStatus);
    };

    // Check authentication status on mount
    checkAuthStatus();

    // Set an interval to check authentication status every second
    const intervalId = setInterval(checkAuthStatus, 1000); // Adjust the interval as needed

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [loggedIn]); // Run only on mount

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []); 

  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthData();
    navigate("/account"); // Redirect to login page
  };
  
  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
 
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  return (
    <>
      <div className='overlay' />
     
  {/* ==================== Mobile Menu Start Here ==================== */}
<div
  className={`mobile-menu scroll-sm d-lg-none d-block ${
    menuActive && "active"
  }`}
>
  <button
    onClick={() => {
      handleMenuToggle();
      setActiveIndex(null);
    }}
    type='button'
    className='close-button'
  >
    <i className='ph ph-x' />{" "}
  </button>
  <div className='mobile-menu__inner'>
    <Link to='/' className='mobile-menu__logo'>
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/logo/blinkBuyBlackLog.png`} 
        alt='Logo'
        style={{ width: '150px', height: 'auto' }}
      />      
    </Link>
    
    <div className='mobile-menu__menu'>
      {/* Nav Menu Start */}
      <ul className='nav-menu flex-align nav-menu--mobile'>
        {/* Home Menu */}
        <li className='nav-menu__item'>
          <NavLink
            to='/'
            className={(navData) =>
              navData.isActive
                ? "nav-menu__link activePage"
                : "nav-menu__link text-white"
            }
            onClick={() => setActiveIndex(null)}
          >
            <HomeIcon sx={{ marginRight: 1 }} /> Home
          </NavLink>
        </li>

        {/* Wallet Menu (Conditional Rendering) */}
        {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER", "ROLE_CUSTOMER"].includes(role)) && (
          <li className='nav-menu__item'>
            <NavLink
              to='/wallet'
              className={(navData) =>
                navData.isActive
                  ? "nav-menu__link activePage"
                  : "nav-menu__link text-white"
              }
              onClick={() => setActiveIndex(null)}
            >
              <AccountBalanceWalletIcon sx={{ marginRight: 1 }} /> Wallet
            </NavLink>
          </li>
        )}

        {/* Orders Menu (Conditional Rendering) */}
        {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
       <li className="nav-menu__item">
       <NavLink
         to="/vendor-orders"
         className={(navData) =>
           navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
         }
         onClick={() => setActiveIndex(null)}
       >
         <span style={{ display: "flex", alignItems: "center" }}>
           <ShoppingCartIcon sx={{ marginRight: 1 }} />
            <Typography variant="body1" sx={{ marginRight: 1 }}>
            Customer Orders
            </Typography>
              {/* Count Badge */}
             <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs">
               {count ?? 0} {/* Display count */}
           </span>
         </span>
       </NavLink>
     </li>
     
        
        )}
        

         {/* Orders Menu (Conditional Rendering) */}
         {roles.some(role => ["ROLE_ADMIN", "ROLE_CUSTOMER"].includes(role)) && (
          <li className='nav-menu__item'>
            <NavLink
              to='/customer-orders'
              className={(navData) =>
                navData.isActive
                  ? "nav-menu__link activePage"
                  : "nav-menu__link text-white"
              }
              onClick={() => setActiveIndex(null)}
            >
              <ShoppingCartIcon sx={{ marginRight: 1 }} />Order
            </NavLink>
          </li>
        )}

        {/* Wholesale Center Menu (Conditional Rendering) */}
        {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
          <li className='nav-menu__item'>
            <NavLink
              to='/wholesale-center'
              className={(navData) =>
                navData.isActive
                  ? "nav-menu__link activePage"
                  : "nav-menu__link text-white"
              }
              onClick={() => setActiveIndex(null)}
            >
              <StorefrontIcon sx={{ marginRight: 1 }} /> Wholesale Center
            </NavLink>
          </li>
        )}

        {/* My Store Menu with Submenu (Conditional Rendering) */}
        {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
  <li
    onClick={() => handleMenuClick(3)} // Toggle submenu visibility
    className={`on-hover-item nav-menu__item has-submenu ${
      activeIndex === 3 ? "d-block" : ""
    }`}
  >
    <Link to='#' className='nav-menu__link text-white'>
      <StoreIcon sx={{ marginRight: 1 }} /> My Store
    </Link>
    <ul
      className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
        activeIndex === 3 ? "open" : ""
      }`}
    >
      <li className='common-dropdown__item nav-submenu__item'>
        <NavLink
          to='/shop'
          className={(navData) =>
            navData.isActive
              ? "nav-menu__link activePage"
              : "nav-menu__link text-white"
          }
          onClick={() => setActiveIndex(null)} // Close submenu on click
        >
          <ShopIcon sx={{ marginRight: 1 }} /> My Store
        </NavLink>
      </li>
      <li className='common-dropdown__item nav-submenu__item'>
        <NavLink
          to='/returned-product'
          className={(navData) =>
            navData.isActive
              ? "nav-menu__link activePage"
              : "nav-menu__link text-white"
          }
          onClick={() => setActiveIndex(null)} // Close submenu on click
        >
          <AssignmentReturnIcon sx={{ marginRight: 1 }} /> Return Products
        </NavLink>
      </li>
    </ul>
  </li>
)}

       
        {/* Dashboard Menu (Conditional Rendering) */}
        {roles.some(role => ["ROLE_VENDER"].includes(role)) && (
          <li className='nav-menu__item'>
            <NavLink
              to='/dashboard-vendor'
              className={(navData) =>
                navData.isActive
                  ? "nav-menu__link activePage"
                  : "nav-menu__link text-white"
              }
              onClick={() => setActiveIndex(null)}
            >
              <DashboardIcon sx={{ marginRight: 1 }} /> Dashboard
            </NavLink>
          </li>
        )}
        {/* Dashboard Menu (Conditional Rendering) */}
        {roles.some(role => ["ROLE_CUSTOMER"].includes(role)) && (
          <li className='nav-menu__item'>
            <NavLink
              to='/dashboard-customer'
              className={(navData) =>
                navData.isActive
                  ? "nav-menu__link activePage"
                  : "nav-menu__link text-white"
              }
              onClick={() => setActiveIndex(null)}
            >
              <DashboardIcon sx={{ marginRight: 1 }} /> Dashboard
            </NavLink>
          </li>
        )}
      
          {loggedIn ? (
                   <li className='nav-menu__item'>
                   <NavLink
                           to='/account'
                           className={(navData) =>
                       navData.isActive
                         ? "nav-menu__link activePage"
                         : "nav-menu__link text-white"
                     }
                     onClick={() => handleLogout()}
                     >
                     <LoginOutlined sx={{ marginRight: 1 }} /> Logout
                   </NavLink>
                 </li>
      ) : (
        <>
                    <NavLink to='/account' 
                    className='text-white flex-align gap-4 item-hover'
                    >
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className="ph ph-user-circle" />

                        </span>
                          Login
                      </NavLink>

                    
                      </>
      )}


      </ul>
      {/* Nav Menu End */}
    </div>
  </div>
</div>
{/* ==================== Mobile Menu End Here ==================== */}

      {/* ======================= Middle Top Start ========================= */}
      <div className='header-top flex-between' style={{ backgroundColor: '#ff6000' }}>
        <div className='container container-lg'>
          <div className='flex-between flex-wrap gap-8'>
            <ul className='flex-align flex-wrap d-none d-md-flex'>
              <li className='border-right-item'>
                <Link
                  to='/become-seller'
                  className='text-white text-sm hover-text-decoration-underline'
                >
                  Become A Seller
                </Link>
              </li> 
            </ul>
            <ul className='header-top__right flex-align flex-wrap'>
             
             
                 
                {loggedIn ? (
        <li className='on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white'>
        <NavLink to='#' className='text-white text-sm  px-20 py-8'>
          My profile
        </NavLink>
        <ul className='on-hover-dropdown common-dropdown common-dropdown--sm max-h-300 scroll-sm py-8'>
  <li className='nav-submenu__item'>
  {isCustomer && (
        <NavLink
          to="/profile"
          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
        >
          <span className="text-sm d-flex">
            <i className="ph ph-user-circle text-lg" /> {/* Correct icon class */}
          </span>
          Profile
        </NavLink>
      )}

      {isVendor && (
        <NavLink
          to="/vendor-profile"
          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
        >
          <span className="text-sm d-flex">
            <i className="ph ph-user-circle text-lg" /> {/* Correct icon class */}
          </span>
          Profile
        </NavLink>
      )}
  </li>

  <li className='nav-submenu__item'>
    <NavLink
      to='/wallet'
      className='nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0'
    >
      <span className='text-sm d-flex'>
        <i className='ph ph-wallet text-lg' /> {/* Correct icon class for Balance */}
      </span>
      Wallet
    </NavLink>
  </li>
  
  <li className='nav-submenu__item'>
  {!isVendor && (
       
    <NavLink
    to='/become-seller'
    className='nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0'
  >
    <span className='text-sm d-flex'>
      <i className='ph ph-storefront text-lg' /> {/* Correct icon class for Seller */}
    </span>
    Become a seller
  </NavLink>
      )}
  </li>
   
</ul>
      </li>
      ) : (
        <></>
      )}
             </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
            {/*      <header className='bg-color-one  border-bottom border-gray-100'> */}

      <header className='' style={{ backgroundColor: '#c94a10' }}>
        <div className='container container-lg'>
          <nav className='header-inner flex-between'>
            {/* Logo Start */}
            <div className='logo'>
              <Link to='/' className='link'>
                        <img
                          src={`/assets/images/logo/blinkBuyWhiteLog.png`} 
                          alt='Logo'
                          style={{ width: '180px', height: 'auto' }}
                          /> 
               </Link>
            </div>
            {/* Logo End  */} 

            {/* Header Middle Right start */}
            <div className='header-right flex-align d-lg-block d-none'>
              <div className='flex-align flex-wrap gap-12'>
                <button
                  type='button'
                  className='search-icon flex-align d-lg-none d-flex gap-4 item-hover'
                >
                  <span className='text-2xl text-white d-flex position-relative item-hover__text'>
                    <i className='ph ph-magnifying-glass' />
                  </span>
                </button>
                      {isLoggedInCustomer ? (
                        <>       <NavLink to='/compare-list' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className='ph-fill ph-shuffle' />
                        <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                        {compare.length}
                          </span>
                        </span>
                         <span className='text-md text-white item-hover__text d-none d-lg-flex'>

                          Compare
                        </span>
                      </NavLink>
                      <NavLink to='/wishlist' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph ph-heart' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                            {wishList.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Wishlist
                        </span>
                      </NavLink>
                      <NavLink to='/cart' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph ph-shopping-cart-simple' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                            {cartItems.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Cart
                        </span>
                      </NavLink></>
      ) : (
        <></>
      )}
         
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header ${
          scroll && "fixed-header"
        }`}
        style={{ backgroundColor: '#c94a10' }}
      >
        <div className='container container-lg'>
          <nav className='header-inner d-flex justify-content-between gap-8'>
            <div className='flex-align menu-category-wrapper'>
              {/* Category Dropdown Start */}
              <div className='category on-hover-item'>
                <button 
                   type='button'
                  className='category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-white'
                >
                  <span className='icon text-2xl d-xs-flex d-none'>
                    <i className='ph ph-dots-nine' />
                  </span>
                  <span className='d-sm-flex d-none'>Blink Buy</span> Dropshipping
                   
                </button> 
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className='header-menu d-lg-block d-none'>
                {/* Nav Menu Start */}
                <ul className='nav-menu flex-align '>
                  
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link text-white"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className='on-hover-item nav-menu__item'>
                  {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER","ROLE_CUSTOMER"].includes(role)) && 
                  (
 
                   <>
 
                    <NavLink to='/wallet' className='nav-menu__link text-white'>
                    wallet
                    </NavLink> 
                   </>
                 )} 
                 
                  </li>
                 
                  <li className='on-hover-item nav-menu__item'>
 
                 {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && 
                  (
 
                   <>
 
                    <NavLink to='/vendor-orders' className='nav-menu__link text-white'>
                    <span style={{ display: "flex", alignItems: "center" }}>
             <Typography variant="body1" sx={{ marginRight: 1 }}>
            Customer Orders
            </Typography>
              {/* Count Badge */}
             <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs">
               {count ?? 0} {/* Display count */}
           </span>
         </span>
                             </NavLink> 
                   </>
                 )}
                  </li>
                  {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && 
                    (
                      <>
                         <li className='on-hover-item nav-menu__item'>
                       <span className='badge-notification bg-tertiary-600 text-white text-sm py-2 px-8 rounded-4'>
                      Post to store 
                    </span>
                    <NavLink to='/wholesale-center' className='nav-menu__link text-white'>
                    Wholesale Center
                    </NavLink>
                    

                    </li> 
                    <li className='on-hover-item nav-menu__item has-submenu arrow-white'>
                   
                    <Link to='#' className='nav-menu__link text-white'>
                      My Store
                    </Link>
                    <ul className='on-hover-dropdown common-dropdown nav-submenu scroll-sm'>
                   
                      <li className='common-dropdown__item nav-submenu__item'>
                        <NavLink
                          to='/shop'
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          My Store
                        </NavLink>
                      </li>
                      <li className='common-dropdown__item nav-submenu__item'>
                        <NavLink
                          to='/returned-product'
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          Return Products
                        </NavLink>
                      </li>
                     
                    </ul>
                  </li>
                          
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/dashboard-vendor'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link text-white"
                      }
                    >
                      Dashbord
                    </NavLink>
                  </li>
                    </>
                    )}
                     <li className='on-hover-item nav-menu__item'>
                 
                 {roles.some(role => ["ROLE_ADMIN","ROLE_CUSTOMER"].includes(role)) && 
                  (
 
                   <>
 
                    <NavLink to='/customer-orders' className='nav-menu__link text-white'>
                    Orders
                    </NavLink> 
                   </>
                 )}
                  </li>
                  <li className='on-hover-item nav-menu__item'>
                 
                 {roles.some(role => ["ROLE_ADMIN","ROLE_CUSTOMER"].includes(role)) && 
                  (
 
                   <>
 
                    <NavLink to='/dashboard-customer' className='nav-menu__link text-white'>
                    Dashbord

                    </NavLink> 
                   </>
                 )}
                  </li>

                  
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className='header-right flex-align'>
            {loggedIn ? (
        <button
          onClick={handleLogout}
          className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
        >
          <div className="d-flex text-32">
            <i className="ph ph-sign-out" />
          </div>
          Logout
        </button>
      ) : (
        <Link
          to="/account"
          className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
        >
          <div className="d-flex text-32">
            <i className="ph ph-user-circle" />
          </div>
          Login
        </Link>
      )}
              <div className='me-16 d-lg-none d-block'>
                <div className='flex-align flex-wrap gap-12'>
                   
                  {isLoggedInCustomer ? (
                        <>   
                            <NavLink to='/compare-list' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className='ph-fill ph-shuffle' />
                        <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                        {compare.length}
                          </span>
                        </span>
                         <span className='text-md text-white item-hover__text d-none d-lg-flex'>

                          Compare
                        </span>
                      </NavLink>
                      <NavLink to='/wishlist' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph ph-heart' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                          {wishList.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Wishlist
                        </span>
                      </NavLink>
                      <NavLink to='/cart' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph ph-shopping-cart-simple' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                          {cartItems.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Cart
                        </span>
                      </NavLink>
                      </>
      ) : (
        <>

                      {loggedIn ? (
      

<NavLink
  to='/account'
  className='text-white flex-align gap-4 item-hover'
  onClick={handleLogout} // Add the onClick event to handle logout
>
  <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
    <i className="ph ph-user-circle" />
  </span>
  Logout
</NavLink>

      ) : (
           <NavLink to='/account' 
                    className='text-white flex-align gap-4 item-hover'
                    >
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className="ph ph-user-circle" />

                        </span>
                          Login
                      </NavLink>
      )}
                    
                      </>
      )}
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type='button'
                className='toggle-mobileMenu d-lg-none ms-3n text-white text-4xl d-flex'
              >
                {" "}
                <i className='ph ph-list' />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderFooter;
